import {Component} from "@angular/core";
import {ProcessReportBase} from "../process-report-base";

@Component({
    selector: "app-process-report",
    templateUrl: "./process-report.component.html",
    styleUrls: ["./process-report.component.scss"]
})
export class ProcessReportComponent extends ProcessReportBase {
}
